import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  STUDENT_QUIZ_BY_ID,
  STUDENT_QUIZ_LIST, // STUDENT_QUIZ_ALL,
  // STUDENT_QUIZ_SELECT
} from '../constants/actionTypes'

const selector = (state: RootState) => prop(GLOBAL_STATE, state)

export const studentQuizByIdSelector = createSelector(selector, data => data[STUDENT_QUIZ_BY_ID])

// export const studentQuizAllSelector = createSelector(selector, data => data[STUDENT_QUIZ_ALL])

export const studentQuizListSelector = createSelector(selector, data => data[STUDENT_QUIZ_LIST])

// export const studentQuizSelectSelector = createSelector(selector, data => data[STUDENT_QUIZ_SELECT])
